import moment from 'moment'
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Store, Task, TaskId } from '../model/types'
import NumberInput from './NumberInput.vue'

@Component({
  components: {
    NumberInput
  }
})
export default class TaskNode extends Vue {
  @Prop() store!: Store;
  @Prop() id!: TaskId;

  private showActions = false

  private mouseEnter () {
    this.showActions = true
  }

  private mouseLeave () {
    this.showActions = false
  }

  @Emit()
  private addPrerequisite () {
    this.showActions = false
  }

  @Emit()
  private addDependent () {
    this.showActions = false
  }

  @Emit('delete')
  private handleDelete () {
    this.showActions = false
  }

  private toggleComplete () {
    if (this.task.completedAt === null) {
      const project = this.store.project
      const now = new Date()

      const completeTask = (id: TaskId) => {
        project.tasks[id].completedAt = now
        for (const [/* dependencyId */, dependency] of Object.entries(project.dependencies)) {
          if (dependency.dependent !== id) continue

          const prereqTask = project.tasks[dependency.prereq]
          if (prereqTask.completedAt !== null) continue

          completeTask(dependency.prereq)
        }
      }

      completeTask(this.id)
    } else {
      this.task.completedAt = null
    }

    this.changeEstimate()
  }

  @Emit()
  private changeEstimate () {
    // Event is emitted by decorator.
  }

  private changePriority (priority: number | null) {
    // If user asks to change the task priority, then detect the direction in
    // which it changed and alter it such that after priority re-condensing
    // (performed by ProjectEditor), it will end up at the user's requested
    // priority if possible.
    //
    // e.g. If the user requested to move the task from priority 1 to 2, set it
    // to 2.5 so that the existing priority 2 task will become priority 1 and
    // this will become priority 2.
    const oldPriority = this.task.priority
    if (priority === null) {
      this.task.priority = null
    } else if (oldPriority === null || oldPriority > priority) {
      this.task.priority = priority - 0.5
    } else {
      this.task.priority = priority + 0.5
    }
    this.changeEstimate()
  }

  private get task (): Task {
    return this.store.project.tasks[this.id]
  }

  private get completed (): boolean {
    return this.task.completedAt !== null
  }

  private get completionDate (): string {
    let completionDate
    if (this.task.completedAt !== null) {
      completionDate = this.task.completedAt
    } else if (this.task.estimatedCompletion === null || this.task.priority === null) {
      return ''
    } else {
      completionDate = this.task.estimatedCompletion
    }

    return moment(completionDate).format('MMM D')
  }
}
